import BaseRepository from "./BaseRepository";
import BOMProjectAPICall from "../service/BOMProjectAPICall";

class BOMProjectRepository extends BaseRepository {
    listProject = async () => {
        return await new BOMProjectAPICall().listProject();
    };
    listProjectDetailWithBOM = async () => {
        return await new BOMProjectAPICall().listProjectDetailWithBOM();
    };
    createProject = async (projectName, bomId = false) => {
        return await new BOMProjectAPICall().createProject({projectName, bomId});
    };
    editProject = async (projectName, projectId) => {
        return await new BOMProjectAPICall().editProject({
            projectName, projectId
        });
    };
    fetchSingleProject = async (projectId) => {
        return await new BOMProjectAPICall().fetchSingleProject({
            projectId
        });
    };
    deleteSingleProject = async (projectId) => {
        return await new BOMProjectAPICall().deleteProject({
            projectId
        });
    };
}

export default BOMProjectRepository;